
import { useEffect, useState } from "react";
import { useAuth } from "@/context/SafeAuthProvider";
import { useNavigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    // Add a small delay to ensure auth state is stable
    const checkAuthTimer = setTimeout(() => {
      if (!loading && !user) {
        // Don't redirect if we're already on settings page and context is loading
        if (location.pathname === "/settings") {
          console.log("ProtectedRoute: On settings page, checking auth state");
        }
        setShouldRedirect(true);
      } else if (user) {
        setShouldRedirect(false);
      }
    }, 200); // 200ms delay to allow context to stabilize

    return () => clearTimeout(checkAuthTimer);
  }, [user, loading, location.pathname]);

  useEffect(() => {
    if (shouldRedirect) {
      navigate("/auth");
    }
  }, [shouldRedirect, navigate]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6127A0]"></div>
      </div>
    );
  }

  // Only render children if authenticated
  return user ? <>{children}</> : null;
};

export default ProtectedRoute;
